module.exports = __webpack_public_path__ + "img/网格化智能林火预警平台.3cec1162.png";